<template>
  <div>
    <px-view-header title="Fornecedores" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-indicadores-fornecedor-header @change="onChangeFilter"/>
    <px-fornecedor-data-table
      :registros="fornecedores"
      :totalizadores="totalizadores"
      :options-list="optionsList"
      :loading="loading"
      @change-options="onChangeOptions"/>
    <px-indicadores-fonecedor-charts v-if="showCharts"
                                     :fornecedores="fornecedores.content"
                                     :loading="loading"/>
  </div>
</template>

<script>
// import LineChart from './LineChart.vue';
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import IndicadoresFornecedorHeader from './IndicadoresFornecedorHeader.vue';
import FornecedorDataTable from './FornecedorDataTable.vue';
import IndicadorFornecedorService from './indicador-fornecedor';
import IndicadoresFonecedorCharts from './IndicadoresFonecedorCharts.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      breadcrumbs: [
        { text: 'Indicadores' },
        { text: 'Fornecedores' },
      ],
      listOptions: {
        page: 1,
        limit: 5,
        offset: 0,
        filter: '',
        sort: 'total',
        sortDesc: true,
      },
      optionsList: {},
      loading: false,
      fornecedores: {
        content: [],
        total: 0,
      },
      totalizadores: null,
    };
  },
  computed: {
    ...mapGetters('indicadoresFornecedor', ['stringFilter', 'showCharts', 'tipoProduto']),
  },
  methods: {
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getFornecedores();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getFornecedores();
    },
    getFornecedores() {
      const query = this.buildQuery(this.listOptions);
      this.loading = true;
      const { limit, offset } = this.listOptions;
      IndicadorFornecedorService.getIndicadores({
        limit,
        offset,
        query,
        tipoProduto: this.tipoProduto,
      })
        .then((response) => {
          this.fornecedores = response.data;
          return this.getTotalizadores();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getTotalizadores() {
      this.loading = true;
      IndicadorFornecedorService.getTotalizadores({
        query: this.buildQuery(this.listOptions),
        tipoProduto: this.tipoProduto,
      })
        .then((response) => {
          this.totalizadores = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
  components: {
    // pxLineChart: LineChart,
    pxIndicadoresFonecedorCharts: IndicadoresFonecedorCharts,
    pxFornecedorDataTable: FornecedorDataTable,
    pxIndicadoresFornecedorHeader: IndicadoresFornecedorHeader,
  },
};
</script>
